import { render } from "./FeatureGrid.vue?vue&type=template&id=5f42dda7"
import script from "./FeatureGrid.vue?vue&type=script&lang=js"
export * from "./FeatureGrid.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__